import { FleetVehicle } from "services/api/fleet/vehicles/types";
import { ListingTemplate } from "services/api/settings/listings/types";

/**
 * Vrijednosti varijabli predloška za konkretno vozilo. Ključevi prate
 * LISTING_TEMPLATE_VARIABLES; ono čega vozilo nema ostaje prazan string.
 */
const buildValues = (vehicle: FleetVehicle | null): Record<string, string> => {
  const type = vehicle?.vehicleType ?? null;

  const power = type?.maximumPowerKw != null
    ? `${type.maximumPowerKw} kW${type.maximumPowerHp != null ? ` (${type.maximumPowerHp} KS)` : ""}`
    : "";

  return {
    marka: vehicle?.vehicleManufacturer?.name ?? "",
    model: vehicle?.vehicleModel?.name ?? "",
    tip: type?.name ?? "",
    godina: vehicle?.vehicleModel?.year != null ? String(vehicle.vehicleModel.year) : "",
    kilometraza: vehicle?.kmTraveled != null ? `${vehicle.kmTraveled.toLocaleString("hr-HR")} km` : "",
    snaga: power,
    gorivo: type?.fuelType?.name ?? "",
    mjenjac: type?.transmission?.name ?? "",
    boja: vehicle?.colorName ?? "",
    vin: vehicle?.vinNumber ?? "",
    registracija: vehicle?.registrationPlate ?? "",
  };
};

/** Zamjenjuje {varijable} vrijednostima vozila; nepoznate ostavlja kako jesu. */
export const renderTemplateText = (text: string, vehicle: FleetVehicle | null): string => {
  const values = buildValues(vehicle);

  return text.replace(/\{(\w+)\}/g, (match, code: string) =>
    code in values ? values[code] : match
  );
};

/** Naslov i opis oglasa iz predloška, s popunjenim varijablama. */
export const applyListingTemplate = (
  template: ListingTemplate,
  vehicle: FleetVehicle | null
): { baseTitle: string; baseDescription: string } => ({
  baseTitle: renderTemplateText(template.titleTemplate, vehicle),
  baseDescription: renderTemplateText(template.descriptionTemplate, vehicle),
});
